"use client"

import clsx from "clsx"
import { useState } from "react"
import { npPageWidthClassName, npSectionMtClassName } from "src/components/np-design/components/constants"
import { useEventCallback } from "src/hooks/useEventCallback"
import { YouTubeIframe } from "src/integrations/youtube/YouTubeIframe"
import { YouTubeIframePreview } from "src/integrations/youtube/YouTubeIframePreview"

export type NpYouTubeVideoProps = {
  videoId: string
  videoTitle: string
}

export const NpYouTubeVideo = ({ videoId, videoTitle }: NpYouTubeVideoProps) => {
  const [clicked, setClicked] = useState(false)
  const onClick = useEventCallback(() => setClicked(true))

  return (
    <section
      title={videoTitle}
      aria-label={"YouTube-Video: " + videoTitle}
      className={clsx(npSectionMtClassName, npPageWidthClassName)}
    >
      <div
        className={clsx(
          "w-page:rounded-3xl relative flex aspect-video items-center justify-center overflow-hidden bg-black",
          npPageWidthClassName,
        )}
      >
        {clicked ? (
          <YouTubeIframe videoId={videoId} />
        ) : (
          <YouTubeIframePreview videoId={videoId} videoTitle={videoTitle} onClick={onClick} />
        )}
      </div>
    </section>
  )
}
